import { RESIGNATION_REQUEST_LABEL } from "./lifecycleApprovalDesk";

/** Must match RequestStatusDeskModal ALL_DESK_TYPES. */
export const ALL_DESK_TYPES = "All";

/** Module bucket for desk type pills (row grouping). */
export const DESK_TYPE_MODULE_BY_LABEL = {
  "Regularise checks": "Attendance",
  Leave: "Attendance",
  "Leave cancellation": "Attendance",
  "Regularise checks cancellation": "Attendance",
  "On Duty cancellation": "Attendance",
  "Change WO cancellation": "Attendance",
  "Restricted Holiday cancellation": "Attendance",
  "Overtime cancellation": "Attendance",
  "Comp Off cancellation": "Attendance",
  "Comp Off Work cancellation": "Attendance",
  "Change Shift cancellation": "Attendance",
  "Short Leave cancellation": "Attendance",
  "Change Shift": "Attendance",
  "Change WO": "Attendance",
  "Short Leave": "Attendance",
  "On Duty": "Attendance",
  "Comp Off": "Attendance",
  "Comp Off Credit": "Attendance",
  Overtime: "Attendance",
  "Restricted Holiday": "Attendance",
  "Attendance Lock": "Attendance",
  "Attendance Unlock": "Attendance",
  "Attendance Finalization": "Attendance",
  [RESIGNATION_REQUEST_LABEL]: "Employee",
  "Resignation Approval": "Employee",
  "Termination Approval": "Employee",
  "Termination / Separation Approval": "Employee",
  "Resignation Task": "Employee",
  "Termination Task": "Employee",
  "Resignation Letter Task": "Employee",
  "Termination Letter Task": "Employee",
  "Confirmation Task": "Employee",
  "Confirmation Letter Task": "Employee",
  "Transfer Task": "Employee",
  "Transfer Letter Task": "Employee",
  "Onboarding Letter Task": "Employee",
  "Employee Onboarding Approval": "Employee",
  "Onboarding Task": "Employee",
  "Confirmation Approval": "Employee",
  "Transfer Approval": "Employee",
  "Exit / Separation Approval": "Employee",
  Ticket: "Helpdesk",
  "Tax Planning": "Payroll",
  "Reimbursement Opt-in": "Payroll",
  "Reimbursement Claim": "Payroll",
  MRF: "Hiring",
  Announcements: "Communication",
  "Asset Request": "Assets",
  "Asset Return": "Assets",
  "Asset Recovery": "Assets",
  "Asset Scrap": "Assets",
  "Asset Verification": "Assets",
};

export const DESK_MODULE_ORDER = [
  "Attendance",
  "Employee",
  "Payroll",
  "Helpdesk",
  "Hiring",
  "Assets",
  "Other",
];

export function getDeskTypeModule(typeLabel) {
  if (!typeLabel || typeLabel === ALL_DESK_TYPES) return null;
  return DESK_TYPE_MODULE_BY_LABEL[typeLabel] || "Other";
}

/** Approvals: highest pending count first; All is handled separately (always first). */
export function sortDeskTypesByBadgeDesc(types, badgeCounts = {}) {
  return [...types]
    .filter((t) => t !== ALL_DESK_TYPES)
    .sort((a, b) => {
      const diff = (badgeCounts[b] ?? 0) - (badgeCounts[a] ?? 0);
      if (diff !== 0) return diff;
      return String(a).localeCompare(String(b));
    });
}

/** Group type labels into module buckets for inline row layout. */
export function groupDeskTypesByModule(typeLabels, badgeCounts = {}, { sortByBadgeDesc = false } = {}) {
  let labels = (typeLabels || []).filter((t) => t && t !== ALL_DESK_TYPES);
  if (sortByBadgeDesc) {
    labels = sortDeskTypesByBadgeDesc(labels, badgeCounts);
  }
  const bucket = new Map();
  labels.forEach((label) => {
    const mod = getDeskTypeModule(label);
    if (!bucket.has(mod)) bucket.set(mod, []);
    bucket.get(mod).push(label);
  });
  return DESK_MODULE_ORDER.filter((mod) => bucket.has(mod)).map((mod) => ({
    module: mod,
    types: bucket.get(mod),
  }));
}
